<template>
  <div class="hp-main">
    <section class="main-banner-hp">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="mb-content-wrapper">
              <h3>HelpNow AI</h3>
              <h2>대화형 AI 서비스를 위한 <br class="pcblock"/>가장 완벽한 플랫폼</h2>
              <p>
                단순 고객 문의부터 기업의 복잡한 비즈니스 워크플로우까지 <br class="pcblock"/>대화형 AI 에이전트와의 상호 작용을 통해 자동화합니다.
              </p>
              <a target="_blank" href="https://drive.google.com/file/d/1iOFQFeoE27yhEcdRNMsf7cjiHknwAdZv/view?usp=sharing" class="btn_white mr_r10">상품소개서</a>
              <a href="https://www.bespinglobal.com/contact/" target="_blank" title="문의하기 이동" class="btn_white_br">문의하기</a>
            </div>
          </div>
          <div class="col-lg-6 align-self-end">
            <div class="mb-image">
              <img src="@/assets/image/img_helpnow_main.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="row-hp-pd main-product">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="tit_hp">HelpNow AI Product</h1>
            <h3 class="subtit_hp">HelpNow AI는 대화형 AI를 위한 End-to-End 서비스를 제공합니다.</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="box-product">
              <img src="@/assets/image/img_helpnow_product01.png"/>
              <h3>Conversational AI</h3>
              <p class="pd20 txt_main_product">
                대화를 이해하고 상호작용하는 AI를 통해 <br class="pcblock"/>
                고객 지원 및 비즈니스 프로세스를 자동화합니다.

              </p>
              <p>
                <a class="btn btn-default" @click="onChangeRoute('conversationalAi', $event)" role="button">자세히 보기</a>
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="box-product">
              <img src="@/assets/image/img_helpnow_product02.png"/>
              <h3>AI Contact Center</h3>
              <p class="pd20 txt_main_product">
                컨택센터에 AI, Cloud 기술을 접목하여 <br class="pcblock"/>
                디지털 컨택센터로 전환합니다
              </p>
              <p>
                <a class="btn btn-default" @click="onChangeRoute('aicc', $event)" role="button">자세히 보기</a>
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="box-product">
              <img src="@/assets/image/img_helpnow_product03.png"/>
              <h3>Professional Service</h3>
              <p class="pd20 txt_main_product">
                클라우드 전문가와 AI/ML 전문가가 <br class="pcblock"/>챗봇・음성봇・AICC 구축 및 운영을 지원합니다.
              </p>
              <p>
                <a class="btn btn-default" href="https://www.bespinglobal.com/contact/" target="_blank" title="문의하기 이동" role="button">전문가와 상담하세요</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
      <!--btn-->
    <!-- <section class="row-hp-btn pd_b50">
      <div class="container">
        <div class="row mr-b80">
          <div class="col-md-12 txt_center">
            <a class="btn_purple" href="https://www.bespinglobal.com/contact/" target="_blank" title="문의하기 이동" target="_blank" title="" onclick="">문의하기</a>
          </div>
        </div>
      </div>
    </section> -->
      <!--btn-->
    <section class="row-hp-pd main-characteristic">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="tit_hp">HelpNow AI와 함께 디지털 혁신을 경험하세요.</h1>
            <h3 class="subtit_hp">고객 서비스, HR 지원, 마케팅 및 IT 헬프데스크 등 용도에 맞는 지능형 에이전트를 생성하여 <br class="pcblock"/>
            고객 및 직원에게 개인화되고 자동화된 경험을 제공합니다.</h3>
          </div>
        </div>
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-6 pcblock txt_center">
              <img :src="onCurrAccordionImage" class="img_characteristic"/>
            </div>
            <div class="col-md-6">
              <div class="panel-group accordion" id="myCollapsible" v-for="(item, index) in accordion" :key="index">
                <div class="panel panel-default" @click="onActiveAccordion(item.imageUrl, index)"
                  :class="{
                    'active': onCurrAccordion == index, 
                  }">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                    <a class="first" role="button">
                      {{item.title}} <span></span>
                    </a>
                    </h4>
                  </div>
                  <div class="panel-collapse collapse in">
                    <div class="panel-body">
                      <p>
                        {{item.content}}
                      </p>
                      <div class="mblock wrap_mbolie_c"><img :src="item.imageUrl" class="img_mbolie_characteristic"/></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="row-hp-pd120 main-service">
      <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h1 class="tit_hp">뛰어난 확장성 및 유연한 업무 연계 구조의 대화형 AI 플랫폼</h1>
          <h3 class="subtit_hp">HelpNow AI는 여러 서비스와 연계하여 대화형 AI 서비스에 필요한 모든 기능을 통합적으로 제공합니다.</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 txt_center">
          <img src="@/assets/image/img_main_05.jpg"/>
        </div>
      </div>
      </div>
    </section>
    <section class="row-hp-pd main-customer pd_b150">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="tit_hp">고객사례</h1>
            <!-- <h3 class="subtit_hp mr-b60">엔터프라이즈급 대화형 AI로 고객 및 직원 서비스를 자동화합니다.</h3> -->
          </div>
        </div>
        <div class="row">
          <slick class="items wrap_cutomer" ref="slick" :options="slickOptions">
            <div class="card">
              <div class="card-body">
                <h5 class="card-sub-title">글로벌 종합 물류 기업 – H사</h5>
                <h3 class="card-title">솔루션 한번의 도입으로, 모든 팀/부서에서 비즈니스 목적에 따라 다양한 봇 즉시 개발</h3>
                <div class="template-box">
                  <p>
                    전사 표준 챗봇 시스템으로 HelpNow AI를 도입하여 각 사업부에서 필요에 따라 Multi-Tenancy 기반으로 챗봇 및 보이스봇을 신속하게 구성하고 배포합니다.
                  </p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="card-sub-title">콜센터 아웃소싱 – K사</h5>
                <h3 class="card-title">콜센터 장비와 즉시 연동 가능한 SaaS형 HelpNow AI 플랫폼 통해 단기간에 AICC 구현</h3>
                <div class="template-box">
                  <p>
                    전통적인 콜센터에서 AI Contact Center로의 전환을 통해 상담 업무 효율성을 향상하고 고객에게 챗봇과 보이스봇을 통한 차별화된 무인 상담 서비스를 추가로 제공하여 비즈니스 가치를 높입니다.
                  </p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="card-sub-title">신용카드 – H사</h5>
                <h3 class="card-title">고성능 NLU 엔진으로 마이그레이션 및 NLU 학습 모델 튜닝을 통해 챗봇 성능 17% 향상</h3>
                <div class="template-box">
                  <p>
                    기존에 운영하던 챗봇 시스템을 고성능 NLU 엔진으로 마이그레이션하고 NLU 학습 모델을 개선하여 인텐트 분류 성능을 17% 이상 향상시켰습니다.
                  </p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="card-sub-title">글로벌 종합 물류 기업 – H사</h5>
                <h3 class="card-title">CSP Translator API와 연계한 다국어 챗봇을 통해 다양한 언어의 글로벌 협력사 문의 자동화</h3>
                <div class="template-box">
                  <p>
                    글로벌 협력사의 단순 반복 문의 업무를 챗봇으로 대체하여 임직원의 업무 부담을 감소시키고 업무 효율성을 향상합니다.
                  </p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="card-sub-title">코스메틱 / 전자상거래 – L사</h5>
                <h3 class="card-title">딥러닝 기반의 개인화 추천 챗봇을 통해 고객의 취향 및 선호도에 맞는 맞춤 상품 추천</h3>
                <div class="template-box">
                  <p>
                    Google Recommendation AI 등 CSP의 AI 기술과 연계하여 고객 취향에 따른 제품 추천 등 개인화 서비스를 제공합니다.
                  </p>
                </div>
              </div>
            </div>
          </slick>
        </div>
      </div>
    </section>
    <section class="row-hp-btn-bg pd_b50">
    <div class="container">
    <div class="row">
      <div class="col-md-12 txt_center">
        <h1>With HelpNow AI</h1>
        <h3>HelpNow AI와 함께 새로운 변화를 경험해 보세요.</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 txt_center">
        <a target="_blank" href="https://drive.google.com/file/d/1iOFQFeoE27yhEcdRNMsf7cjiHknwAdZv/view?usp=sharing" class="btn_white mr_r10">상품소개서</a>
        <a href="https://www.bespinglobal.com/contact/" target="_blank" title="문의하기 이동" class="btn_white_br">문의하기</a>
      </div>
    </div>
    </div>
    </section>
  </div>
</template>

<script>
import Slick from 'vue-slick';
import $ from 'jquery'; 

  export default {
    name: 'Main',
    components: {
      Slick
    },
    data() {
      return {   
        slickOptions: {
          dots: true,
          infinite: true,
          speed: 800,
          autoplay: true,
          autoplaySpeed: 2000,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [{
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      infinite: true,
                      dots: true
                  }
              },
              {
                  breakpoint: 991,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                  }
              }

          ]
        },

        onCurrAccordion: '', 
        onCurrAccordionImage: '', 
        accordion: [
          {
            title: '기업용 챗봇, 콜봇, AICC 구축 도입부터 클라우드 운영까지 한번에', 
            content: 'HelpNow AI는 챗봇, 콜봇은 물론 컨택센터 시스템에 AI 및 Cloud 기술을 접목한 클라우드 기반의 AICC 구축 및 운영을 위한 모든 서비스를 제공합니다.', 
            imageUrl: require("@/assets/image/img_main_01.png"), 
          },
          {
            title: '사용자의 말을 이해하고 상호 작용하는 고성능 AI 에이전트', 
            content: 'Google, AWS, MS, Naver, Kakao 등 최고 성능의 AI/ML 기술과 결합하여 채팅, 메신저, AI 스피커, 콜센터 등 다양한 채널에서 원활한 셀프 서비스가 가능합니다.', 
            imageUrl: require("@/assets/image/img_main_02.png"), 
          },
          {
            title: '코딩 없이 다양한 사례에 맞는 대화형 AI 서비스 신속 구현', 
            content: '강력한 소프트웨어 엔지니어링과 높은 수준의 AI 전문 지식 없이도 고객사 니즈에 맞는 가상 에이전트를 빠르게 개발하여 배포할 수 있습니다.', 
            imageUrl: require("@/assets/image/img_main_03.png"), 
          },
          {
            title: '솔루션 기반으로 봇 성능을 정확하게 평가하고 개선', 
            content: '몇 분 만에 봇 성능을 테스트하여 평가 분석하며, 딥러닝 기반의 자동학습을 통해 NLP 모델의 품질을 크게 개선하여 봇 성능을 향상시킵니다.', 
            imageUrl: require("@/assets/image/img_main_04.png"), 
          },
        ]
      }
    },
    computed: {},
    watch: {},
    created(){},
    mounted(){
      this.onActiveAccordion(this.accordion[0].imageUrl, 0); 
    },
    beforeDestroy() {},
    methods: {
      onChangeRoute(routeName, event) {
        event.preventDefault();
        this.$router.push({name: routeName})

        window.scrollTo(0, 0); 
      }, 

      onActiveAccordion(url, index) {
        this.onCurrAccordion = index; 
        this.onCurrAccordionImage = url; 
      }
    }
  }
</script>

<style lang="scss" scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/Main.vue